// extracted by mini-css-extract-plugin
export default {"container":"Close_container__I-68-"};